import { LAYOUTS, } from "@voltmoney/types";
import { SizeTypeTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { getEmailStatement, goBack } from "./actions";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { Platform } from "react-native";
export const template = (height) => {
    return {
        layout: {
            id: ROUTE.EMAIL_STATEMENT,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                Platform.OS === "ios" ? { id: "space56", type: WIDGET.SPACE } : {},
                { id: 'EmailStatementPage', type: WIDGET.EMAIL_STATEMENT_PAGE }
            ]
        },
        datastore: {
            EmailStatementPage: {
                height: height,
                goBack: {
                    routeId: ROUTE.EMAIL_STATEMENT,
                    type: ACTION.GO_BACK,
                    payload: {}
                },
                getEmailStatementAction: {
                    routeId: ROUTE.EMAIL_STATEMENT,
                    type: ACTION.GET_EMAIL,
                    payload: {}
                },
                emailStatementButtonLoading: false,
            },
            space56: {
                size: SizeTypeTokens.XXXL
            }
        },
    };
};
export const emailStatementMf = {
    onLoad: async (_) => {
        const height = _.getHeight();
        const userContextResponse = await _.network.post(api.userContext, {}, { headers: await getAppHeader() });
        const _user = userContextResponse?.data;
        return Promise.resolve(template(height));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.GET_EMAIL]: getEmailStatement,
        [ACTION.MENU]: goBack,
    },
};
